/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_KotlinInputs */

const en_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin`)
};

const ar_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كوتلن`)
};

const bn_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin`)
};

const de_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin`)
};

const es_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin`)
};

const fr_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin`)
};

const pt_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin`)
};

const zh_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`科特林`)
};

const tr_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin`)
};

const ru_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Котлин`)
};

const pl_svchip_kotlin = /** @type {(inputs: Svchip_KotlinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlina`)
};

/**
* | output |
* | --- |
* | "Kotlin" |
*
* @param {Svchip_KotlinInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_kotlin = /** @type {((inputs?: Svchip_KotlinInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_KotlinInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_kotlin(inputs)
	if (locale === "bn") return bn_svchip_kotlin(inputs)
	if (locale === "de") return de_svchip_kotlin(inputs)
	if (locale === "es") return es_svchip_kotlin(inputs)
	if (locale === "fr") return fr_svchip_kotlin(inputs)
	if (locale === "pt") return pt_svchip_kotlin(inputs)
	if (locale === "zh") return zh_svchip_kotlin(inputs)
	if (locale === "tr") return tr_svchip_kotlin(inputs)
	if (locale === "ru") return ru_svchip_kotlin(inputs)
	if (locale === "pl") return pl_svchip_kotlin(inputs)
	return en_svchip_kotlin(inputs)
});